import { useQuery } from '@tanstack/react-query'

import { get } from '../apiClient'
import { pincodeResponseSchema } from '../../../common/validations/reservationSchema'
import { API_ENDPOINTS } from '../../../common/apiEndpoints'

const params = (
  contractUuid: string,
  reservationId: number,
  enabled: boolean
) => {
  const path = API_ENDPOINTS.RESERVATION_PINCODE.replace(
    ':contractUuid',
    contractUuid
  ).replace(':reservationId', reservationId.toString())

  return {
    queryKey: ['reservation-pincode', contractUuid, reservationId],
    queryFn: async () => {
      return get(path, pincodeResponseSchema)
    },
    enabled,
  }
}

export const useAPIGetReservationPincode = (
  contractUuid: string,
  reservationId: number,
  enabled: boolean
) => {
  return useQuery(params(contractUuid, reservationId, enabled))
}
